export const GET_STUDENTS = "GET_STUDENTS";
export const GET_STUDENT = "GET_STUDENT";
export const IMPORTED_STUDENTS = "IMPORTED_STUDENTS";
